import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { getTokenFontStyle } from '@elfsight/widget-ui';

export interface CheckoutFormStyleProps {
  fieldColor: string;
  fieldFillColor: string;
  fieldActiveColor: string;

  fieldBorderType: 'outline' | 'underline' | null;
  fieldBorderColor: string;
  fieldBorderWidth: number;
  fieldBorderRadius: number;

  fieldLabelPosition: 'inside' | 'outside';
  fieldLabelColor: string;
  fieldInsideLabelColor: string;
  fieldLabelFontStyle: TextStyleValue;
  fieldInsideLabelFontStyle: TextStyleValue;

  fieldFontStyle: TextStyleValue;
  fieldHintColor?: string;
  fieldHintFontStyle?: TextStyleValue;

  fieldSpacing: number;
}

const text16 = getTokenFontStyle('text16');

export const defaultCheckoutFormStyleProps: CheckoutFormStyleProps = {
  fieldColor: '#111111',
  fieldFillColor: 'transparent',
  fieldActiveColor: '#197BFF',

  fieldBorderType: 'outline',
  fieldBorderColor: 'rgba(17, 17, 17, 0.2)',
  fieldBorderWidth: 1,
  fieldBorderRadius: 8,

  fieldLabelPosition: 'inside',
  fieldLabelColor: '#111111',
  fieldInsideLabelColor: 'rgba(17, 17, 17, 0.5)',

  fieldLabelFontStyle: text16,
  fieldInsideLabelFontStyle: text16,
  fieldFontStyle: text16,

  fieldHintColor: 'rgba(17, 17, 17, 0.5)',
  fieldHintFontStyle: getTokenFontStyle('text13'),

  fieldSpacing: 20
};

export interface FormFieldStyleProps {
  fieldActiveColor?: string;

  fieldColor?: string;
  fieldLabelColor?: string;
  fieldInsideLabelColor?: string;
  fieldHeadingColor?: string;
  fieldHintColor?: string;

  fieldFillColor?: string;

  fieldBorderType?: 'outline' | 'underline' | null;
  fieldBorderColor?: string;
  fieldBorderWidth?: number;
  fieldBorderRadius?: number;

  fieldLabelPosition?: 'inside' | 'outside';
  fieldLabelOnlyOutside?: boolean;
  fieldLabelOutsideStyle?: boolean;

  fieldFontStyle?: TextStyleValue;
  fieldLabelFontStyle?: TextStyleValue;
  fieldInsideLabelFontStyle?: TextStyleValue;
  fieldHeadingFontStyle?: TextStyleValue;
  fieldHintFontStyle?: TextStyleValue;

  fieldSpacing?: number;
  fieldPadding?: number;

  fieldHintInsideTypes?: string[];

  errorColor?: string;
  invalidErrorText?: string;
  requiredErrorText?: string;
  hideErrors?: boolean;
  highlightError?: boolean;
}

export interface FormColorsProps {
  headingColor: string;

  descriptionColor?: string;

  submitButtonColor?: string;

  fieldLabelColor?: string;
  fieldTextColor?: string;
  fieldHintColor?: string;
  fieldBorderColor?: string;
  fieldActiveColor?: string;
  fieldInsideLabelColor?: string;

  errorColor?: string;
}
